import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import EChallanRegNo from "../e-challan-reg-no";

const EChallanHeroBannerV2 = ({
    heroBannerData,
    heading = "Check Traffic Challan Status & Pay Online",
    regNumberList = [],
    isState
}) => {

    const {
        title = "",
        description = [],
        bannerData = {},
        inputChallanData = {},
        backgroundImage = {}
    } = heroBannerData || {};

    const url = bannerData?.mobileImage?.url || backgroundImage?.url || "";

    return (
        <>
            <div styleName={"styles.backgroundWrapper"} />
            <div styleName={"styles.contentWrapper"}>
                <div styleName={"styles.content"}>
                    <h1>{title}</h1>
                    <div styleName={"styles.contentList"}>
                        {
                            description.map((item, index) => (
                                <div key={`point_${index}`}>
                                    <p>{isState && "✅ "}{item.text ? item.text : item?.title}</p>
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div styleName={"styles.formWrapper"}>
                    <img fetchpriority="high" src={url} alt={heading} styleName={"styles.banner"} />
                    <div styleName={"styles.formContainer"}>
                        <EChallanRegNo isChallanRevamp challanCountData={inputChallanData} regNumberList={regNumberList} />
                    </div>
                </div>
            </div>
        </>
    );
};

EChallanHeroBannerV2.propTypes = {
    heading: PropTypes.string,
    heroBannerData: PropTypes.object,
    regNumberList: PropTypes.array,
    isState: PropTypes.bool
};

export default EChallanHeroBannerV2;
